import { createTheme } from "@mui/material/styles";

// Define light mode properties in a JSON object
const lightModeConfig = {
  palette: {
    mode: "light",
    primary: {
      main: "#0D47A1",
    },
    secondary: {
      main: "#9c27b0",
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
    text: {
      primary: "#000000",
    },
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
    h5: {
      fontWeight: 600,
    },
  },
};

// Define dark mode properties in a JSON object
const darkModeConfig = {
  palette: {
    mode: "dark",
    primary: {
      main: "#121212",
    },
    secondary: {
      main: "#ce93d8",
    },
    background: {
      default: "#121212",
      paper: "#000000",
    },
    text: {
      primary: "#ffffff",
    },
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
    h5: {
      fontWeight: 600,
    },
  },
};

// Function to generate the theme based on the mode
const getTheme = (mode) => {
  const themeConfig = mode === "light" ? lightModeConfig : darkModeConfig;
  return createTheme(themeConfig);
};

export default getTheme;
